<template>
  <div id="editCategoryList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto">
          <p class="font16" v-if="contentDto.id === 0">新建内容类别</p>
          <p class="font16" v-else>新编内容类别</p>
        </div>
        <div style="width: auto">
          <button @click="saveContent" class="redButtonTwo">保存</button>
          <button class="cancelButtonTwo" @click="allReturn">返回</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <nav class="m_l_10"><i class="VioletDot"></i><abbr class="font16">类别信息</abbr></nav>
      <ul class="allUL">
        <li><span><i class="colorRed m_r_5">*</i><abbr>类别名称：</abbr></span><input v-model="contentDto.typeName" type="text" class="allInput" style="width: 50%"/></li>
        <li><span><i class="colorRed m_r_5">*</i><abbr>类别状态：</abbr></span>
          <input v-model="contentDto.isEnable" :value="true" type="radio" class="allRadio" id="radio1" name="contentRadio"/>
          <label for="radio1"></label><abbr>有效</abbr>
          <input v-model="contentDto.isEnable" :value="false" type="radio" class="allRadio" id="radio2" name="contentRadio"/>
          <label for="radio2"></label><abbr>无效</abbr>
        </li>
        <li><span><i class="colorRed m_r_5">*</i><abbr>Content Owner：</abbr></span><div class="d_i" style="width: calc(100% - 120px);vertical-align: top">
          <div class="d_flex m_b_10">
            <div class="navP">
              <p>
                <input @input="searcOwnerhUser($event, 1)" class="allInput" type="text" placeholder="姓名，邮箱" >
              </p>
<!--              <p>-->
<!--                <button class="redButton">-->
<!--                  <i class="icon iconfont iconsousuo"></i>-->
<!--                  搜索-->
<!--                </button>-->
<!--              </p>-->
            </div>
            <div>
              <button class="redButtonTwo" @click="addMemberUser(1)">添加</button>
            </div>
          </div>
          <div class="adaptive">
            <table cellspacing="0" class="allTable">
              <thead>
              <tr>
                <th>姓名</th>
                <th>部门</th>
                <th>邮箱</th>
<!--                <th>权限</th>-->
                <th>&nbsp;</th>
              </tr>
              </thead>
              <tbody>
              <tr class="ownerUserList" :key="index" v-for="(item, index) in contentDto.ownersList">
                <td width="20%">{{item.name}}</td>
                <td width="30%">{{item.org_Acronym}}</td>
                <td width="30%">{{item.email}}</td>
<!--                <td width="25%">{{item.promissions}}</td>-->
                <td width="20%" class="t_c"><i @click="removeUser(index, 1)" class="icon iconfont iconzhengfangxingjian colorCH"></i></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        </li>
        <li><span><i class="colorRed m_r_5">*</i><abbr>Content Editor：</abbr></span><div class="d_i" style="width: calc(100% - 120px);vertical-align: top">
          <div class="d_flex m_b_10">
            <div class="navP">
              <p>
                <input @input="searcOwnerhUser($event, 2)"  class="allInput" type="text" placeholder="姓名，邮箱">
              </p>
<!--              <p>-->
<!--                <button class="redButton">-->
<!--                  <i class="icon iconfont iconsousuo"></i>-->
<!--                  搜索-->
<!--                </button>-->
<!--              </p>-->
            </div>
            <div>
              <button class="redButtonTwo" @click="addMemberUser(2)">添加</button>
            </div>
          </div>
          <div class="adaptive">
            <table cellspacing="0" class="allTable">
              <thead>
              <tr>
                <th>姓名</th>
                <th>部门</th>
                <th>邮箱</th>
<!--                <th>权限</th>-->
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr class="editUserList" :key="index" v-for="(item, index) in contentDto.editorsList">
                <td width="20%">{{item.name}}</td>
                <td width="30%">{{item.org_Acronym}}</td>
                <td width="30%">{{item.email}}</td>
<!--                <td width="25%">{{item.promissions}}</td>-->
                <td width="20%" class="t_c"><i @click="removeUser(index, 2)" class="icon iconfont iconzhengfangxingjian colorCH"></i></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        </li>
      </ul>
    </div>
    <userPicker :title="title" v-on:choosedConfirm="confirUserPicker($event)" v-model="showUserPicker"></userPicker>
    <model v-if="membershowModel" :buttonType="0" :title="'提示'" :minWidth="'1000px'" v-on:on-cancel="cancelModel()"  v-on:on-confirm="confirModel()">
      <nav class="t_c font24" style="padding: 3% 0"><i class="icon iconfont icongantan m_r_10 colorCH" style="font-size: 26px;vertical-align: baseline"></i><span class="colorZh">确定将该成员从{{myTitle}}列表中删除</span></nav>
      <div class="modelHeight" style="max-height: 323px;overflow: auto;padding: 0 10%">
        <table cellspacing="0" class="allTable alltableHui">
          <thead>
          <tr style="background-color: #FBFBFB;color: #797979">
            <th>姓名</th>
            <th>部门</th>
            <th>邮箱</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td width="20%">{{appList.name}}</td>
            <td width="40%" style="max-width: 230px" class="NoWrap">{{appList.org_Acronym}}</td>
            <td width="40%" style="max-width: 230px" class="NoWrap">{{appList.email}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'editCategoryList',
  data () {
    return {
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      userInfo: JSON.parse(window.sessionStorage.getItem('userInfo')),
      title: '',
      selectUserType: 1,
      showUserPicker: false,
      membershowModel: false,
      contentDto: {
        id: this.$route.params.id,
        typeName: '',
        isEnable: true,
        owners: [],
        ownersList: [],
        editors: [],
        editorsList: []
      },
      delModel: false,
      showModel: false,
      tabSwitch: 1,
      totalPage: 1,
      page: 1,
      postData: {
        depart: '',
        name: ''
      },
      appList: {},
      myIndex: '',
      myTitle: '',
      myNewTYpe: ''
    }
  },
  created () {
    if (parseInt(this.contentDto.id) !== 0) {
      this.getDetail()
    }
  },
  methods: {
    getDetail () {
      this.$axiox.get('/api/contentType/' + this.contentDto.id).then(msg => {
        let data = msg.result
        data.ownersList = JSON.parse(JSON.stringify(data.owners))
        data.editorsList = JSON.parse(JSON.stringify(data.editors))
        data.owners = []
        data.editors = []
        for (let i = 0; i < data.ownersList.length; i++) {
          data.ownersList[i].id = data.ownersList[i].userId
          data.owners.push(data.ownersList[i].userId)
        }
        for (let i = 0; i < data.editorsList.length; i++) {
          data.editorsList[i].id = data.editorsList[i].userId
          data.editors.push(data.editorsList[i].userId)
        }
        this.contentDto = data
      })
    },
    removeUser (index, type) {
      this.membershowModel = true
      this.myNewTYpe = type
      this.myIndex = index
      if (type === 1) {
        this.myTitle = 'Content Owner'
        this.appList = JSON.parse(JSON.stringify(this.contentDto.ownersList[index]))
      } else {
        this.myTitle = 'Content Editor'
        this.appList = JSON.parse(JSON.stringify(this.contentDto.editorsList[index]))
      }
      // if (type === 1) {
      //   this.contentDto.ownersList.splice(index, 1)
      //   this.contentDto.owners.splice(index, 1)
      // } else {
      //   this.contentDto.editorsList.splice(index, 1)
      //   this.contentDto.editors.splice(index, 1)
      // }
    },
    searcOwnerhUser (e, type) {
      if (type === 1) {
        let domList = document.querySelectorAll('.ownerUserList')
        if (domList) {
          for (let i = 0; i < domList.length; i++) {
            if (this.contentDto.ownersList[i].email.indexOf(e.target.value) >= 0 || this.contentDto.ownersList[i].name.indexOf(e.target.value) >= 0) {
              domList[i].style.display = ''
            } else {
              domList[i].style.display = 'none'
            }
          }
        }
      } else {
        let domList = document.querySelectorAll('.editUserList')
        if (domList) {
          for (let i = 0; i < domList.length; i++) {
            if (this.contentDto.editorsList[i].email.indexOf(e.target.value) >= 0 || this.contentDto.editorsList[i].name.indexOf(e.target.value) >= 0) {
              domList[i].style.display = ''
            } else {
              domList[i].style.display = 'none'
            }
          }
        }
      }
    },
    addMemberUser (type) {
      this.selectUserType = type
      this.showUserPicker = true
      if (type === 1) {
        this.showModel = true
        this.title = '添加Content Owner'
      } else {
        this.showModel = true
        this.title = '添加Content Editor'
      }
    },
    getList () {
    },
    confirModel () {
      if (this.myNewTYpe === 1) {
        this.contentDto.ownersList.splice(this.myIndex, 1)
        this.contentDto.owners.splice(this.myIndex, 1)
      } else {
        this.contentDto.editorsList.splice(this.myIndex, 1)
        this.contentDto.editors.splice(this.myIndex, 1)
      }
      this.membershowModel = false
    },
    cancelModel () {
      this.showModel = false
      this.membershowModel = false
    },
    // 返回上一页
    allReturn () {
      this.$router.go(-1)
    },
    confirUserPicker (e) {
      if (this.selectUserType === 1) {
        for (let i = 0; i < e.chooseUserList.length; i++) {
          let flag = true
          for (let j = 0; j < this.contentDto.ownersList.length; j++) {
            if (e.chooseUserList[i].id === this.contentDto.ownersList[j].id) {
              flag = false
            }
          }
          if (flag) {
            this.contentDto.ownersList.push(e.chooseUserList[i])
            this.contentDto.owners.push(e.chooseUserList[i].id)
          }
        }
      }
      if (this.selectUserType === 2) {
        for (let i = 0; i < e.chooseUserList.length; i++) {
          let flag = true
          for (let j = 0; j < this.contentDto.editorsList.length; j++) {
            if (e.chooseUserList[i].id === this.contentDto.editorsList[j].id) {
              flag = false
            }
          }
          if (flag) {
            this.contentDto.editorsList.push(e.chooseUserList[i])
            this.contentDto.editors.push(e.chooseUserList[i].id)
          }
        }
      }
    },
    saveContent () {
      if (this.contentDto.typeName === '' || this.contentDto.ownersList.length <= 0 || this.contentDto.editorsList.length <= 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '请检查必填项！',
          stayTime: 5
        })
        return
      }
      if (parseInt(this.contentDto.id) === 0) {
        this.$axiox.post('/api/contentType/Add', this.contentDto).then(msg => {
          this.$axiox.get('/api/contentType/fromuser/' + this.userInfo.id).then(msg2 => {
            let editorTypes = JSON.parse(JSON.stringify(msg2.result.editorTypes))
            let ownerTypes = JSON.parse(JSON.stringify(msg2.result.ownerTypes))
            window.localStorage.setItem('canEditList', JSON.stringify(msg2.result.editorTypes))
            let conbineList = this.$commonJs.distinct(editorTypes, ownerTypes)
            if (this.nowApp) {
              if (this.nowApp.roles.indexOf('ContentOwner') >= 0 && this.nowApp.roles.indexOf('ContentEditor') >= 0) {
                window.sessionStorage.setItem('myContentList', JSON.stringify(conbineList))
              } else {
                //   if (item.roles.indexOf('ContentOwner') >= 0) {
                //     window.sessionStorage.setItem('myContentList', JSON.stringify(ownerTypes))
                //   }
                //   if (item.roles.indexOf('ContentEditor') >= 0) {
                //     window.sessionStorage.setItem('myContentList', JSON.stringify(editorTypes))
                //   }
                if (this.nowApp.roles.indexOf('ContentOwner') >= 0 && this.nowApp.roles.indexOf('ContentEditor') >= 0) {
                  window.sessionStorage.setItem('myContentList', JSON.stringify(conbineList))
                } else {
                  if (this.nowApp.roles.indexOf('ContentOwner') >= 0) {
                    window.sessionStorage.setItem('myContentList', JSON.stringify(ownerTypes))
                  } else if (this.nowApp.roles.indexOf('ContentEditor') >= 0) {
                    window.sessionStorage.setItem('myContentList', JSON.stringify(editorTypes))
                  } else {
                    window.sessionStorage.setItem('myContentList', JSON.stringify([]))
                  }
                }
              }
            }
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '保存成功',
              stayTime: 5
            })
            this.contentDto.id = msg.result
            let allContenturl = this.$commonJs.returnQuery('/api/contentType/all', {pageIndex: 1, pageSize: 99999})
            this.$axiox.get(allContenturl).then(msg => {
              window.sessionStorage.setItem('allContentType', JSON.stringify(msg.result.items))
            })
            this.$router.go(-1)
          })
        })
      } else {
        this.$axiox.post('/api/contentType/Edit', this.contentDto).then(msg => {
          this.$axiox.get('/api/contentType/fromuser/' + this.userInfo.id).then(msg2 => {
            let editorTypes = JSON.parse(JSON.stringify(msg2.result.editorTypes))
            let ownerTypes = JSON.parse(JSON.stringify(msg2.result.ownerTypes))
            window.localStorage.setItem('canEditList', JSON.stringify(msg2.result.editorTypes))
            let conbineList = this.$commonJs.distinct(editorTypes, ownerTypes)
            if (this.nowApp) {
              if (this.nowApp.roles.indexOf('ContentOwner') >= 0 && this.nowApp.roles.indexOf('ContentEditor') >= 0) {
                window.sessionStorage.setItem('myContentList', JSON.stringify(conbineList))
              } else {
                //   if (item.roles.indexOf('ContentOwner') >= 0) {
                //     window.sessionStorage.setItem('myContentList', JSON.stringify(ownerTypes))
                //   }
                //   if (item.roles.indexOf('ContentEditor') >= 0) {
                //     window.sessionStorage.setItem('myContentList', JSON.stringify(editorTypes))
                //   }
                if (this.nowApp.roles.indexOf('ContentOwner') >= 0 && this.nowApp.roles.indexOf('ContentEditor') >= 0) {
                  window.sessionStorage.setItem('myContentList', JSON.stringify(conbineList))
                } else {
                  if (this.nowApp.roles.indexOf('ContentOwner') >= 0) {
                    window.sessionStorage.setItem('myContentList', JSON.stringify(ownerTypes))
                  } else if (this.nowApp.roles.indexOf('ContentEditor') >= 0) {
                    window.sessionStorage.setItem('myContentList', JSON.stringify(editorTypes))
                  } else {
                    window.sessionStorage.setItem('myContentList', JSON.stringify([]))
                  }
                }
              }
            }
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '保存成功',
              stayTime: 5
            })
            let allContenturl = this.$commonJs.returnQuery('/api/contentType/all', {pageIndex: 1, pageSize: 99999})
            this.$axiox.get(allContenturl).then(msg => {
              window.sessionStorage.setItem('allContentType', JSON.stringify(msg.result.items))
            })
            this.$router.go(-1)
          })
        })
      }
    }
  }
}
</script>

<style scoped>
  @media screen and (max-width: 1370px){
    .modelHeight {
       min-height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/mainDateManager/editCategoryList.vue